module.exports = __webpack_public_path__ + "static/media/mgs.897a7496.png";